export const __ReviewCardLang = {
    service: 'خدمت',
    noReview: 'نظری توسط کاربر ثبت نشده است',
};
